module.exports = __webpack_public_path__ + "static/media/img4.1e3acf98.jpg";